import gql from "graphql-tag";
import api from "../apiClient";

export default {
  list: () =>
    api
      .send({
        query: gql`
          query documento {
            TYPES {
              Documento {
                readAll {
                  id
                  value
                  annotation
                }
              }
            }
          }
        `,
      })
      .then((result) => result.data.data.TYPES.Documento.readAll),
};
